import React from 'react'
import { Col} from 'react-bootstrap'

function Footer() {
  return (
    <>
      <div className='row-12 mt-3'>
        <Col lg={12}>
          <div className='footer-text'>
            <p>
              © 2025 Brainrock Consulting Services. | All Right Reserved.
            </p>


          </div>
        </Col>
      </div>
    </>
  )
}

export default Footer